import React, { Component } from "react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Descriptions } from "antd";
import BooleanCheckboxField from "../../../ui/data-fields/BooleanCheckboxField";
import { defaultCurrencyFormat } from "../../../../utilities";
import PropTypes from "prop-types";

/**
 * Shows all the details about an insurance policy, that's about to be confirmed by the user.
 */
@withRouter
@observer
class ConfirmationDetails extends Component {
	static propTypes = {
		clientData: PropTypes.object.isRequired,
		insuranceData: PropTypes.object.isRequired,
		hideIpt: PropTypes.bool,
		startingDateForQuote: PropTypes.string,
	};

	render() {
		const {
			clientDataTitle,
			insuranceDataTitle,
			clientData,
			insuranceData,
			areWeUpdatingQuoteOrPolicy,
			hideIpt,
			startingDateForQuote,
		} = this.props;




		return (
			<>
				<Descriptions title={clientDataTitle} bordered size="small" column={1}>
					<Descriptions.Item label="Name">
						{clientData.organisation?.organisationFirstName}{" "}
						{clientData.organisation?.organisationLastName}
					</Descriptions.Item>
					<Descriptions.Item label="Company">
						{clientData.organisation?.organisationName}
					</Descriptions.Item>
					<Descriptions.Item label="Phone">
						{clientData.organisation?.phone}
					</Descriptions.Item>
					<Descriptions.Item label="Email">
						{clientData.organisation?.emailAddress}
					</Descriptions.Item>
					<Descriptions.Item label="Activities">
						{clientData.activityTrades?.map((activity) => (
							<div key={activity}>{activity}&nbsp;&nbsp;</div>
						))}
					</Descriptions.Item>
					<Descriptions.Item label="PL Cover Amount">
						£{clientData.pl_cover_amt}m
					</Descriptions.Item>
					<Descriptions.Item label="Turnover">
						{defaultCurrencyFormat(clientData.pl_turnover)}
					</Descriptions.Item>
					<Descriptions.Item label="Wageroll">
						{defaultCurrencyFormat(clientData.el_wageroll || "")}
					</Descriptions.Item>
					<Descriptions.Item label="Equipment Covered">
						{defaultCurrencyFormat(clientData.equipment_cover_amt || "")}
					</Descriptions.Item>
				</Descriptions>
				<Descriptions
					title={insuranceDataTitle}
					bordered
					size="small"
					column={1}
					style={{ marginTop: "2rem" }}
				>
					{insuranceData.insurer ? (
						<Descriptions.Item label="Insurer">
							{insuranceData.insurer}
						</Descriptions.Item>
					) : (
						<Descriptions.Item label="Insurer">
							{insuranceData.insurerName}
						</Descriptions.Item>
					)}
					{insuranceData.premium ? (
						<Descriptions.Item label="Premium">
							{defaultCurrencyFormat(insuranceData.premium)}
						</Descriptions.Item>
					) : (
						<Descriptions.Item label="Premium">
							{defaultCurrencyFormat(insuranceData.gross_premium)}
						</Descriptions.Item>
					)}
					<Descriptions.Item label="Admin Fee">
						{defaultCurrencyFormat(insuranceData.admin_fee)}
					</Descriptions.Item>
					<Descriptions.Item label="Total">
						{defaultCurrencyFormat(insuranceData.total)}
					</Descriptions.Item>
					{!hideIpt && (
						<Descriptions.Item label="Includes IPT of">
							{defaultCurrencyFormat(insuranceData.ipt_amt)}
						</Descriptions.Item>
					)}
					<Descriptions.Item label="Start date">
						{!areWeUpdatingQuoteOrPolicy ? (new Date(clientData.startDate).toLocaleDateString()) : (new Date(startingDateForQuote).toLocaleDateString())}

					</Descriptions.Item>
				</Descriptions>
			</>
		);
	}
}

export default ConfirmationDetails;
